import ServiceBus from "servicestack/service-bus";
import resolve from "ioc/resolve";
export const DISABLED =
  (ENV_TAGS || []).indexOf("Offline") >= 0 ||
  (ENV_TAGS || []).indexOf("Showroom") >= 0; //webpack.DefinePlugin

export class Recaptcha {
  constructor() {
    this.bus = new ServiceBus();
  }

  init() {
    if (!DISABLED) {
      this.bus
        .read("GetRecaptchaSiteKey.json")
        .then(({ data }) => this.onSiteKeyLoaded(data));
    }
  }

  scrubAction(action) {
    return `${action || ""}`.replace(/[^A-Za-z\/_]+/, "_");
  }

  onSiteKeyLoaded({ siteKey, minScore, failureMessage }) {
    // console.debug(
    //   "GetRecaptchaSiteKey.json",
    //   siteKey,
    //   minScore,
    //   failureMessage
    // );
    if (siteKey) {
      this.siteKey = siteKey;
      this.minScore = minScore;
      this.failureMessage = failureMessage;
      this.loadScript();
    }
  }

  loadScript() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://www.google.com/recaptcha/api.js?render=" + this.siteKey;
    document.body.appendChild(script);
  }

  verify(action = "submit", minScore = this.minScore) {
    if (DISABLED || !(minScore > 0)) {
      return resolve("$q").when(1);
    }
    const scrubbedAction = this.scrubAction(action);
    const deferred = resolve("$q").defer();
    grecaptcha.ready(() =>
      deferred.resolve(
        grecaptcha
          .execute(this.siteKey, { action: scrubbedAction })
          .then((token) =>
            this.bus
              .send("/Recaptcha.json", { token, action: scrubbedAction })
              .then(({ data }) => {
                if (!data.success || data.score < minScore) {
                  console.error("/Recaptcha.json", {
                    token,
                    action,
                    scrubbedAction,
                    minScore,
                    ...data,
                  });
                  resolve("notify").warning(this.failureMessage, {
                    title: `reCAPTCHA Failure (${data.score})`,
                    ttl: 8000,
                  });
                  this.bus.send("/RecaptchaFailed.json", {
                    token,
                    action,
                    minScore,
                    ...data,
                  });
                  throw data;
                }
                console.debug("/Recaptcha.json", {
                  token,
                  action,
                  scrubbedAction,
                  minScore,
                  ...data,
                });
                return data;
              })
          )
      )
    );
    return deferred.promise;
  }
}

export default new Recaptcha();
